// extracted by mini-css-extract-plugin
export var actionButton = "_nn-0";
export var actionMenuContainer = "_nn-i";
export var bubble = "_nn-2";
export var bubbleActionMenu = "_nn-j";
export var bubbleContext = "_nn-6";
export var bubbleItems = "_nn-7";
export var customer = "_nn-3";
export var divider = "_nn-8";
export var fileList = "_nn-9";
export var hiddenComment = "_nn-o";
export var infoAbove = "_nn-a";
export var internal = "_nn-4";
export var lightActionButton = "_nn-1";
export var link = "_nn-b";
export var merchant = "_nn-5";
export var message = "_nn-c";
export var profilePicture = "_nn-e";
export var quillToolbarContainer = "_nn-f";
export var senderDate = "_nn-g";
export var senderDateCustomer = "_nn-h";
export var senderName = "_nn-d";
export var time = "_nn-k";
export var uploadedImage = "_nn-l";
export var username = "_nn-m";
export var xsmall = "_nn-n";